import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const TriggerButton = styled.button`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  background: ${colors.white};
  border: 1px solid ${colors.borderGrey};
  border-radius: ${layout.borderRadius};
  padding: 8px 12px;
  cursor: pointer;
  text-align: left;
  font-family: ${fonts.body};
  outline: none;
  transition: border-color 0.15s ease;

  &:focus {
    border-color: ${colors.primary};
  }
`;

export const TriggerLabel = styled.span`
  font-size: 0.625rem;
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontSecondary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const TriggerValue = styled.span`
  font-size: 0.875rem;
  color: ${colors.fontPrimary};
`;

export const Dropdown = styled.div<{ $inline?: boolean }>`
  position: ${({ $inline }) => ($inline ? 'relative' : 'absolute')};
  top: ${({ $inline }) => ($inline ? '0' : 'calc(100% + 4px)')};
  left: ${({ $inline }) => ($inline ? '0' : '0')};
  z-index: 100;
  background: ${colors.white};
  border: 1px solid ${colors.borderGrey};
  border-radius: ${layout.borderRadius};
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: ${space[4]};
  min-width: 240px;
`;

export const CounterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space[2]} 0;

  & + & {
    border-top: 1px solid ${colors.borderGreyLighter};
  }
`;

export const CounterLabel = styled.span`
  font-family: ${fonts.body};
  font-size: 0.875rem;
  font-weight: ${fonts.weight.medium};
  color: ${colors.fontPrimary};
`;
